import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  MdOutlinePayment,
  MdVisibility,
  MdVisibilityOff,
} from "react-icons/md"; // Added icons
import api from "../utils/api";
import { Button, Skeleton } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { eventActions } from "../redux/eventSlice";
import { noticeActions } from "../redux/noticeSlice";
import { convertToNepaliDate } from "../components/FormatDate";

const Userdash = () => {
  const dispatch = useDispatch();
  const { allNotices, loading: noticesLoading } = useSelector(
    (state) => state.notices
  );
  const { events, loading: eventsLoading } = useSelector(
    (state) => state.events
  );

  const [dueAmount, setDueAmount] = useState(null);
  const [showDueAmount, setShowDueAmount] = useState(false); // Toggle visibility
  const [loadingDue, setLoadingDue] = useState(true);

  useEffect(() => {
    // Fetch due amount from /payments/mydues
    api
      .get("/payments/mydues")
      .then((response) => {
        const amount = response?.data?.data?.due_amount;
        console.log(response.data.data);
        setDueAmount(amount);
        setLoadingDue(false);
      })
      .catch((error) => {
        console.error("Error fetching due amount:", error);
        setDueAmount(0); // fallback
        setLoadingDue(false);
      });

    dispatch(noticeActions.getAllNotices());
    dispatch(eventActions.getEvents());
  }, [dispatch]);

  const toggleDueVisibility = () => {
    setShowDueAmount((prev) => !prev);
  };

  const getNoticeColor = (status) => {
    switch (status) {
      case "private":
        return "bg-[#2563EB] rounded-3xl";
      default:
        return "bg-[#1E3A8A] rounded-3xl";
    }
  };

  return (
    <>
      <div className="flex justify-center">
        <div className="px-4 pb-20 bg-[#F5F5F5]">
          {/* Header Card with Due Amount */}
          <div className="bg-[url('https://static.vecteezy.com/system/resources/previews/003/127/954/non_2x/abstract-template-blue-background-white-squares-free-vector.jpg')] rounded-lg mt-4 p-4 bg-cover flex justify-between items-start">
            <div>
              <div className="mx-4">
                <img
                  src="../assets/images/image.jpeg"
                  alt="tch2 logo"
                  className="rounded-full h-16 w-16"
                />
              </div>
              <div className="mt-2">
                <p className="font-bold text-white">TCH II Thaiba</p>
              </div>
            </div>

            <div className="flex flex-col items-end space-y-3">
              <div className="text-right">
                <p className="text-[16px] font-roboto text-white">Due amount</p>
                <div className="flex items-center gap-2">
                  <p className="text-white text-[16px] font-semibold">
                    {loadingDue
                      ? "Loading..."
                      : showDueAmount
                      ? `NPR. ${Number(dueAmount)?.toFixed(2)}`
                      : "NPR. ••••••"}
                  </p>
                  <button
                    onClick={toggleDueVisibility}
                    className="text-white hover:text-gray-200 transition"
                    disabled={loadingDue}
                  >
                    {showDueAmount ? (
                      <MdVisibilityOff size={18} />
                    ) : (
                      <MdVisibility size={18} />
                    )}
                  </button>
                </div>
              </div>

              <Link to="/adduserpayment">
                <Button
                  icon={<PlusCircleOutlined />}
                  className="bg-[#19891A] text-white"
                >
                  Add Payment
                </Button>
              </Link>
            </div>
          </div>

          {/* Events & Booking Cards */}
          <div className="flex  gap-4 mt-4">
            <Link to="/display-event">
              <div className="w-[165px] h-[100px] rounded-lg bg-[#FDDEE2] p-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="33"
                  height="33"
                  viewBox="0 0 24 24"
                  fill="#F55A89"
                  stroke="#FFFFFF"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-calendar-fold-icon lucide-calendar-fold"
                >
                  <path d="M3 20a2 2 0 0 0 2 2h10a2.4 2.4 0 0 0 1.706-.706l3.588-3.588A2.4 2.4 0 0 0 21 16V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z" />
                  <path d="M15 22v-5a1 1 0 0 1 1-1h5" />
                  <path d="M8 2v4" />
                  <path d="M16 2v4" />
                  <path d="M3 10h18" />
                </svg>

                <h1 className="text-[14px] font-bold font-roboto text-[#F55A89]">
                  Events
                </h1>
                <p className="text-[10px] font-roboto text-[#F55A89]">
                  events happening on your surrounding
                </p>
              </div>
            </Link>

            <Link to="/booking">
              <div className="w-[165px] h-[100px] rounded-lg bg-[#FF7900] bg-opacity-20 p-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="33"
                  height="33"
                  viewBox="0 0 24 24"
                  fill="#ff7700a9"
                  stroke="#FFFFFF"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-book-user-icon lucide-book-user"
                >
                  <path d="M15 13a3 3 0 1 0-6 0" />
                  <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" />
                  <circle cx="12" cy="8" r="2" />
                </svg>
                <h1 className="text-[14px] font-bold font-roboto text-[#ff7700a9]">
                  Booking
                </h1>
                <p className="text-[10px] font-roboto text-[#ff7700a9]">
                  Book your service directly from here without any complications
                </p>
              </div>
            </Link>
            
          </div>
           <div className="flex  gap-4 mt-4">
            <Link to="/generatepass">
              <div className="w-[165px] h-[100px] rounded-lg bg-[#7ac930] bg-opacity-20 p-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="33"
                  height="33"
                  viewBox="0 0 24 24"
                  fill="#7ac930"
                  stroke="#FFFFFF"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-book-user-icon lucide-book-user"
                >
                  <path d="M15 13a3 3 0 1 0-6 0" />
                  <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" />
                  <circle cx="12" cy="8" r="2" />
                </svg>
                <h1 className="text-[14px] font-bold font-roboto text-[#2d5804]">
                 Gate Pass
                </h1>
                <p className="text-[10px] font-roboto text-[#2d5804]">
                  Generate your gate pass easily from here
                </p>
              </div>
            </Link>
           </div>

          <div className="mt-8 pb-20">
            <div className="w-full">
              <h2 className="text-2xl font-bold pb-2 mb-2">Upcoming events</h2>

              {eventsLoading ? (
                <Skeleton active paragraph={{ rows: 2 }} />
              ) : (
                <div className="flex flex-col gap-2">
                  {events.map((item) => (
                    <Link
                      to={`/display-event/event-detail/${item.id}`}
                      key={item?.event?.id}
                      className="flex items-center justify-between bg-white shadow-sm shadow-gray-400 rounded-lg p-4"
                    >
                      <div>
                        <p
                          className="text-md text-ellipsis overflow-hidden capitalize font-semibold"
                          style={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 1,
                          }}
                        >
                          {item?.event?.name}
                        </p>
                        <p className="text-md text-gray-500">
                          {convertToNepaliDate(new Date(item?.date))}
                        </p>
                        <p
                          className="text-md text-gray-600 text-ellipsis overflow-hidden pt-2 w-2/3"
                          style={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                          }}
                        >
                          {item?.description}
                        </p>
                      </div>
                      <img
                        src={item?.file?.original_url}
                        alt="Event"
                        className="h-16 w-16 rounded-lg object-cover"
                      />
                    </Link>
                  ))}

                  {events.length === 0 && (
                    <p className="text-gray-500">No upcoming events.</p>
                  )}

                  {/* Show button only when there is at least one event */}
                  {events.length > 0 && (
                    <div className="mt-4">
                      <Link to="/display-event">
                        <Button
                          className="bg-[#19891A] text-md text-white w-full text-center"
                          style={{ padding: "20px 0px" }}
                        >
                          View more events
                        </Button>
                      </Link>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* ---------- Latest Notices ---------- */}
            <div className="w-full mt-8">
              <h2 className="text-2xl font-bold pb-2 mb-2">Latest Notices</h2>

              {noticesLoading ? (
                <Skeleton active paragraph={{ rows: 2 }} />
              ) : (
                <div className="flex flex-col gap-2">
                  {allNotices.map((item) => (
                    <Link
                      to={`/notice/notice-detail/${item.id}`}
                      className="flex items-center justify-between bg-white shadow-sm shadow-gray-400 rounded-lg p-4"
                      key={item.id}
                    >
                      <div>
                        <p
                          className="text-md text-ellipsis overflow-hidden capitalize font-semibold"
                          style={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 1,
                          }}
                        >
                          {item.title}
                        </p>
                        <p className="text-md text-gray-500">
                          {convertToNepaliDate(new Date(item.created_at))}
                        </p>
                        <p className="pt-2">
                          <span
                            className={`${getNoticeColor(
                              item.notice_type
                            )} text-[12px] px-4 py-1 text-white`}
                          >
                            {item?.notice_type}
                          </span>
                        </p>
                        <p
                          className="text-md text-gray-600 text-ellipsis overflow-hidden pt-2"
                          style={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                          }}
                        >
                          {item?.notice_body}
                        </p>
                      </div>
                    </Link>
                  ))}

                  {/* Show button only when there is at least one notice */}
                  {allNotices.length > 0 && (
                    <div className="mt-4">
                      <Link to="/notice">
                        <Button
                          className="bg-[#19891A] text-md text-white w-full text-center"
                          style={{ padding: "20px 0px" }}
                        >
                          View More Notices
                        </Button>
                      </Link>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Userdash;
